import { ToastProvider } from "@/ds";

import { useEmbarcacoesScreen } from "./use-embarcacoes-screen";
import { EmbarcacoesScreenView } from "./view-embarcacoes";

function EmbarcacoesScreenLigada() {
  const vm = useEmbarcacoesScreen();
  return <EmbarcacoesScreenView {...vm} />;
}

/** Liga o ViewModel à View da tela Embarcações; o `ToastProvider` é o host único dos toasts da tela e do detalhe. */
export function EmbarcacoesScreen() {
  return (
    <ToastProvider position="top-right">
      <EmbarcacoesScreenLigada />
    </ToastProvider>
  );
}

export type * from "./types-embarcacoes";
